import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {aboutData.title}
          </h2>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[700px] mx-auto text-center">
            {aboutData.content}
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-8 md:gap-16">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">
                  {stat.value}
                </div>
                <div className="mt-1 text-sm text-foreground-500">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}